import PreviewsSliderPaging from './previewsSliderPaging';

export default (di) => {
	di
		.setType({type: PreviewsSliderPaging, name: 'PreviewsSliderPaging', parent: 'PageComponent'})
	;
};
